<template>
  <global-widget-block-banner-form
    v-if="type === GLOBAL_WIDGET_TYPES.BANNER"
  />
  <global-widget-block-footer-form
    v-if="type === GLOBAL_WIDGET_TYPES.FOOTER"
  />
</template>

<script>
import { GLOBAL_WIDGET_TYPES } from 'src/models/global-widget/GlobalWidget'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'GlobalWidgetBlockForm',
  components: {
    GlobalWidgetBlockBannerForm: defineAsyncComponent(() => import('src/modules/admin/global-widget/GlobalWidgetBlockBannerForm')),
    GlobalWidgetBlockFooterForm: defineAsyncComponent(() => import('src/modules/admin/global-widget/GlobalWidgetBlockFooterForm'))
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  created () {
    _.extend(this, { GLOBAL_WIDGET_TYPES })
  }
}
</script>
